import { withDefaults } from "./with-defaults.js";
import { DEFAULTS } from "./defaults.js";
const endpoint = withDefaults(null, DEFAULTS);
export {
  endpoint
};
